// extracted by mini-css-extract-plugin
export default {"socials":"socials--CYute","open":"open--AIrs7","toggle-btn":"toggle-btn--YaLc3","toggleBtn":"toggle-btn--YaLc3","btns":"btns--xIVlB"};